import React from 'react'
import { withIcon } from '../../withIcon'

function EyeShowIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.72293 12C5.28748 16.3355 8.38513 18.375 12 18.375C15.6149 18.375 18.7125 16.3355 21.2771 12C18.7125 7.66451 15.6149 5.625 12 5.625C8.38513 5.625 5.28748 7.66451 2.72293 12ZM1.45736 11.6899C4.19213 6.90431 7.69999 4.375 12 4.375C16.3 4.375 19.8079 6.90431 22.5426 11.6899C22.6525 11.8821 22.6525 12.1179 22.5426 12.3101C19.8079 17.0957 16.3 19.625 12 19.625C7.69999 19.625 4.19213 17.0957 1.45736 12.3101C1.34755 12.1179 1.34755 11.8821 1.45736 11.6899ZM12 10.625C11.2406 10.625 10.625 11.2406 10.625 12C10.625 12.7594 11.2406 13.375 12 13.375C12.7594 13.375 13.375 12.7594 13.375 12C13.375 11.2406 12.7594 10.625 12 10.625ZM9.375 12C9.375 10.5503 10.5503 9.375 12 9.375C13.4497 9.375 14.625 10.5503 14.625 12C14.625 13.4497 13.4497 14.625 12 14.625C10.5503 14.625 9.375 13.4497 9.375 12Z" fill={color}/>
    </svg>
  )
}

export default withIcon(EyeShowIcon)
